import React from 'react';
import { useInView } from '../hooks/useInView';

// Caricature of Pamela holding a house
const CARICATURE_URL = 'https://customer-assets.emergentagent.com/job_realty-preview-2/artifacts/oi89rbkc_image.png';

const WelcomeSection = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section ref={ref} className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Caricature */}
          <div
            className={`relative transition-all duration-500 ${
              isInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            <div className="relative flex justify-center lg:justify-start">
              <img
                src={CARICATURE_URL}
                alt="Pam Immobilier - Votre agent immobilier"
                className="w-auto h-[450px] lg:h-[550px] object-contain drop-shadow-2xl transition-transform duration-500 hover:scale-105 relative z-10"
              />
              {/* Animated decorative bubbles - different bordeaux shades */}
              <div className="absolute top-20 -left-4 w-24 h-24 bg-[#8B2942]/25 rounded-full -z-0 animate-float-slow" />
              <div className="absolute bottom-20 right-10 w-32 h-32 bg-[#A13350]/15 rounded-full -z-0 animate-float-medium" />
              <div className="absolute top-1/2 -right-6 w-16 h-16 bg-[#722338]/20 rounded-full -z-0 animate-float-fast" />
              <div className="absolute top-40 right-20 w-12 h-12 bg-[#9E3A5C]/30 rounded-full -z-0 animate-float-reverse" />
            </div>
          </div>

          {/* Content */}
          <div
            className={`transition-all duration-500 delay-100 ${
              isInView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
            }`}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-[#8B2942] mb-6">
              Bienvenue
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Vous souhaitez faire un achat ou mettre en vente votre bien immobilier ? 
              C'est un acte important, <strong className="text-[#8B2942]" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '700', letterSpacing: '0.5px' }}>Pam Immobilier</strong> vous 
              accompagnera tout au long de votre projet.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Mon objectif : réaliser des{' '}
              <span className="text-[#8B2942] font-semibold">
                ventes dans les meilleures conditions
              </span>
              , que ce soit pour le vendeur ou l'acquéreur.
            </p>

            {/* Stats */}
            <div className="mt-10 grid grid-cols-2 gap-6">
              {[
                { number: '10+', label: 'Années d\'expérience' },
                { number: '40+', label: 'Biens vendus' }
              ].map((stat, index) => (
                <div
                  key={index}
                  className={`text-center transition-all duration-500 ${
                    isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                  style={{ transitionDelay: `${200 + index * 50}ms` }}
                >
                  <div className="text-3xl font-bold text-[#8B2942]">{stat.number}</div>
                  <div className="text-sm text-gray-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
